import DocsHelper from "util/DocsHelper";
export const REPOSITORIES_QUERY_KEY = "repositories";
export const REPOSITORIES_SUMMARY_QUERY_KEY = [REPOSITORIES_QUERY_KEY, "summary"];
export const ENTITY_TABLE_ID = "warm-tier-repositories";
export const POLL_INTERVAL_MS = 3e3;
export const MAX_POLL_ATTEMPTS = 20;
const DEFAULT_DISPLAYED_ATTRIBUTES = ["name", "type", "base_path", "credential_user", "status"];
export const DEFAULT_LAYOUT = {
  entityTableId: ENTITY_TABLE_ID,
  defaultPageSize: 20,
  defaultSort: { attributeId: "name", direction: "asc" },
  defaultDisplayedAttributes: DEFAULT_DISPLAYED_ATTRIBUTES,
  defaultColumnOrder: DEFAULT_DISPLAYED_ATTRIBUTES
};
export const WARM_TIER_DOCS = {
  pageHeader: DocsHelper.PAGES.DATA_TIERING,
  setupOpenSearch: DocsHelper.PAGES.DATA_TIERING_WARM_TIER_OPENSEARCH,
  setupDataNode: DocsHelper.PAGES.DATA_TIERING_WARM_TIER_DATA_NODE
};
